import React from 'react';
import { remCss, scssVariables as variables } from 'src/helpers';

const SportsMedicineIcon = React.memo(({ width = 81, height = 80, viewBox = '0 0 81 80' }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={remCss(width)}
    height={remCss(height)}
    viewBox={viewBox}
  >
    <path
      fill={variables['colors-mc-primary']}
      fillOpacity='0.1'
      stroke={variables['colors-mc-primary']}
      d='M80.2144 40C80.2144 61.8153 62.5296 79.5 40.7144 79.5C18.8991 79.5 1.21436 61.8153 1.21436 40C1.21436 18.1848 18.8991 0.5 40.7144 0.5C62.5296 0.5 80.2144 18.1848 80.2144 40Z'
    />
    <g clipPath='url(#clip0_414_17844)'>
      <path
        d='M58.0622 26.7996H49.6573V19.9033C49.6573 18.475 48.4995 17.3171 47.0712 17.3171H29.1838C27.7555 17.3171 26.5976 18.475 26.5976 19.9033V26.7996H18.3005C16.8727 26.7996 15.7144 27.958 15.7144 29.3857V57.9409C15.7144 59.3687 16.8727 60.527 18.3005 60.527H58.0622C59.49 60.527 60.6483 59.3687 60.6483 57.9409V29.3857C60.6483 27.958 59.49 26.7996 58.0622 26.7996ZM30.9079 26.7996V21.9506C30.9079 21.4746 31.2938 21.0886 31.7699 21.0886H44.485C44.9611 21.0886 45.3471 21.4746 45.3471 21.9506V26.7996H30.9079Z'
        fill='#FF6D7A'
      />
      <path
        d='M58.0729 30.0322H24.7658C23.3375 30.0322 22.1797 31.1901 22.1797 32.6184V59.665C22.1797 60.141 21.7937 60.527 21.3176 60.527H18.3005C16.8722 60.527 15.7144 59.3692 15.7144 57.9409V29.3857C15.7144 27.9574 16.8722 26.7996 18.3005 26.7996H58.0622C60.2911 26.7996 60.1757 30.0322 58.0729 30.0322Z'
        fill='#FF8C95'
      />
      <path
        d='M49.6573 19.9033V26.7996H45.3471V21.9506C45.3471 21.4746 44.9611 21.0886 44.485 21.0886H31.7699C31.2939 21.0886 30.9079 21.4746 30.9079 21.9506V26.7996H26.5977V19.9033C26.5977 18.475 27.7555 17.3171 29.1838 17.3171H47.0712C48.4995 17.3171 49.6573 18.475 49.6573 19.9033Z'
        fill='#CBE3FA'
      />
      <path
        d='M47.1605 18.3947H31.4466C30.0184 18.3947 28.8605 19.5525 28.8605 20.9808V26.2617C28.8605 26.5588 28.6197 26.7996 28.3226 26.7996H26.5977V19.9033C26.5977 18.475 27.7555 17.3171 29.1838 17.3171C29.1838 17.3171 47.1574 17.3182 47.2001 17.3203C47.8906 17.3542 47.8519 18.3947 47.1605 18.3947Z'
        fill='#EEF7FF'
      />
      <path
        d='M26.5977 32.8337V54.3848C26.5977 54.8609 26.9836 55.2468 27.4597 55.2468H49.0108C49.4868 55.2468 49.8728 54.8609 49.8728 54.3848V32.8337C49.8728 32.3577 49.4868 31.9717 49.0108 31.9717H27.4597C26.9836 31.9717 26.5977 32.3577 26.5977 32.8337Z'
        fill='#CBE3FA'
      />
      <path
        d='M49.8728 32.8337V33.2647C49.8728 33.7408 49.4868 34.1268 49.0108 34.1268H31.7699C31.2939 34.1268 30.9079 34.5128 30.9079 34.9888V54.3848C30.9079 54.8609 30.5219 55.2468 30.0458 55.2468H27.4597C26.9836 55.2468 26.5977 54.8609 26.5977 54.3848V32.8337C26.5977 32.3577 26.9836 31.9717 27.4597 31.9717H49.0108C49.4868 31.9717 49.8728 32.3577 49.8728 32.8337Z'
        fill='#EEF7FF'
      />
      <path
        d='M44.9159 42.424V44.7946C44.9159 45.7472 44.1443 46.5187 43.1918 46.5187H41.1444V48.566C41.1444 49.5186 40.3729 50.2901 39.4203 50.2901H37.0497C36.0972 50.2901 35.3256 49.5186 35.3256 48.566V46.5187H33.2783C32.3257 46.5187 31.5542 45.7472 31.5542 44.7946V42.424C31.5542 41.4714 32.3257 40.6999 33.2783 40.6999H35.3256V38.6526C35.3256 37.7 36.0972 36.9285 37.0497 36.9285H39.4203C40.3729 36.9285 41.1444 37.7 41.1444 38.6526V40.6999H43.1918C44.1443 40.6999 44.9159 41.4714 44.9159 42.424Z'
        fill='#FF6D7A'
      />
      <path
        d='M21.8562 61.3889C21.3801 61.3889 20.9941 61.003 20.9941 60.5269V25.7219C20.9941 25.2458 21.3801 24.8599 21.8562 24.8599C22.3322 24.8599 22.7182 25.2458 22.7182 25.7219V60.5269C22.7182 61.003 22.3322 61.3889 21.8562 61.3889Z'
        fill='#E84857'
      />
      <path
        d='M54.614 61.3889C54.1379 61.3889 53.752 61.003 53.752 60.5269V25.7219C53.752 25.2458 54.1379 24.8599 54.614 24.8599C55.0901 24.8599 55.476 25.2458 55.476 25.7219V60.5269C55.476 61.003 55.0901 61.3889 54.614 61.3889Z'
        fill='#E84857'
      />
      <path
        d='M65.7145 53.846C65.7145 58.4165 62.2322 62.2062 57.7406 62.6399C53.5693 63.0527 49.7187 60.4642 48.4683 56.5603C47.302 52.9624 48.5628 48.9808 51.6708 46.7072C54.7739 44.4414 58.9792 44.4502 62.0638 46.6921C64.3025 48.3196 65.7145 50.9308 65.7145 53.846Z'
        fill='#CBE3FA'
      />
      <path
        d='M51.7007 57.6378C52.0338 58.6779 52.5695 59.6621 53.2784 60.5259C53.7386 61.0867 53.0779 61.8579 52.4504 61.494C47.2589 58.4836 46.4971 51.2656 50.9991 47.2502C52.9137 45.5375 55.4437 44.7834 57.9014 45.068C58.6163 45.1507 58.6712 46.1651 57.9726 46.3384C53.22 47.5178 50.0669 52.5973 51.7007 57.6378Z'
        fill='#EEF7FF'
      />
      <path
        d='M65.4199 56.1134C65.3439 56.401 65.2503 56.6939 65.14 56.9844C65.0592 57.1972 64.8237 57.3078 64.6069 57.2386L60.4918 55.9257C60.0381 55.7813 59.7881 55.2964 59.9325 54.8427C60.0769 54.3891 60.5618 54.138 61.0154 54.2835L65.133 55.5971C65.35 55.6664 65.4782 55.8931 65.4199 56.1134Z'
        fill='#9EC7F0'
      />
      <path
        d='M62.4224 46.9664C62.6015 47.111 62.6375 47.3697 62.5026 47.5562L59.9713 51.0562C59.304 51.9802 57.9056 50.9704 58.5748 50.0454L61.107 46.5448C61.2426 46.3574 61.5009 46.3118 61.6947 46.4381C61.9492 46.6038 62.1943 46.7823 62.4224 46.9664Z'
        fill='#9EC7F0'
      />
      <path
        d='M53.2397 55.9343L49.1544 57.2461C48.9367 57.3161 48.7007 57.2041 48.6194 56.9904C48.5093 56.7013 48.4158 56.4104 48.3392 56.1239C48.28 55.9029 48.4073 55.6746 48.6252 55.6047L52.7397 54.2835C53.8516 53.9361 54.3494 55.6208 53.2397 55.9343Z'
        fill='#9EC7F0'
      />
      <path
        d='M53.7905 51.0605L51.2366 47.5737C51.1013 47.3892 51.1327 47.1297 51.3103 46.9853C51.5451 46.7943 51.7913 46.6144 52.0455 46.4477C52.2368 46.3223 52.4933 46.3706 52.6285 46.5552L55.1804 50.0411C55.8607 50.9715 54.4481 51.9626 53.7905 51.0605Z'
        fill='#9EC7F0'
      />
      <path
        d='M57.7408 57.9408V62.2393C57.7408 62.4681 57.5624 62.6587 57.3339 62.6705C57.0317 62.686 56.7258 62.686 56.4235 62.6705C56.195 62.6587 56.0166 62.4681 56.0166 62.2393V57.9408C56.0167 56.7999 57.7408 56.8002 57.7408 57.9408Z'
        fill='#9EC7F0'
      />
      <path
        d='M54.8757 50.4646C56.7211 50.0946 58.201 50.3301 58.8853 50.47C59.1377 50.5216 59.353 50.6845 59.4739 50.9122C60.1044 52.0996 60.521 53.3865 60.7061 54.7176C60.7416 54.9723 60.6628 55.2289 60.4909 55.4201C60.0123 55.9525 58.8909 57.0431 57.2259 57.7768C57.0045 57.8745 56.7512 57.8738 56.5295 57.7767C55.2901 57.2336 54.1746 56.4295 53.2641 55.4102C53.0967 55.2228 53.0191 54.9713 53.0526 54.7222C53.144 54.0413 53.4054 52.5655 54.2904 50.9023C54.4101 50.6768 54.6254 50.5148 54.8757 50.4646Z'
        fill='#585966'
      />
    </g>
    <defs>
      <clipPath id='clip0_414_17844'>
        <rect width='50' height='50' fill='white' transform='translate(15.7144 15)' />
      </clipPath>
    </defs>
  </svg>
));
SportsMedicineIcon.displayName = 'SportsMedicineIcon';

export default SportsMedicineIcon;
